import { Component,
  OnInit, Input, EventEmitter,
  Output, AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

/**
 * This component will display a numeric value defined with the "data"
 * attribute. A user can click the value and edit it. The component will
 * emit an event if the value was changed.
 *
 * This component detects all changes manually for performance reasons,
 * if you decide to modify it in the future please remember to call
 * detect changes when something alters the view.
 *
 * Currently this component only supports the "number" input type.
 */
@Component({
  selector: 'get-click-to-edit',
  templateUrl: './get-click-to-edit.component.html',
  styleUrls: ['./get-click-to-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class GETClickToEditComponent implements OnInit, AfterViewInit, OnChanges {
  displayData: number;
  @Input() data: number;
  @Output() dataChanged: EventEmitter<number> = new EventEmitter();
  @Input() alignRight = false;
  @Input() editable = true;
  editing = false;
  @Output() dataChange: EventEmitter<number> = new EventEmitter<number>();
  constructor(private _cdr: ChangeDetectorRef) { }

  updateDisplayVal() {
    this._cdr.detectChanges();
  }


  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
   if (propName === 'data') {
      this.data = changes[propName].currentValue;
      this.dataChange.emit(this.data);
   }
  }
}

  ngOnInit() {
  }

  ngAfterViewInit() {
    this._cdr.detach();
  }

  /**
   * When the user clicks on the text value and
   * wants to edit it, call this.
   */
  public onTextClicked() {
    this.editing = true;
    this._cdr.detectChanges();
  }

  /**
   * When the user clicks out of the number input, hide the
   * input box unless the value has been changed.
   * @param {number} value The value in the number input box.
   */
  public onInputBlur(value: any) {
    if (value === this.data) {
      this.editing = false;
      this._cdr.detectChanges();
    }
  }

  /**
   * When the user clicks the cancel icon, hide the
   * number input and don't update the value.
   */
  public onCancelClicked() {
    this.editing = false;
    this._cdr.detectChanges();
  }

  /**
   * When the user clicks save, if they have changed the
   * value in the input, emit that the value has changed as
   * an event. Also hide the input.
   * @param {any} value The value in the number input.
   */
  public onSaveClicked(value: any) {
    if (this.data !== value) {
      this.data = value;
      this.dataChanged.emit(value);
    }
    this.editing = false;
    this._cdr.detectChanges();
  }
}
